import { cloneDeep } from 'lodash';
import { useQueryClient } from 'react-query';
import { DocketCaseDocument } from '../../models/CompanyDockets';
import { queryKeys } from '../queryKeyFactory';
import { CaseDocumentsQueryFilters, UseFetchCaseDocumentQueryResult } from './useFetchCaseDocuments';

export default (
  docket: DocketCaseDocument | undefined,
  page: number,
  pageSize: number,
  filters: CaseDocumentsQueryFilters,
  keyFilings: boolean
): { toggleSeeMore: () => void } => {
  const queryClient = useQueryClient();

  const toggleSeeMore = () => {
    if (!docket) {
      return;
    }

    const queryKey = queryKeys.dockets.fetchDocuments.query(
      docket.docketItemCaseId,
      page,
      pageSize,
      filters,
      keyFilings
    );
    const documents = queryClient.getQueryData<UseFetchCaseDocumentQueryResult>(queryKey)!;

    const documentIndex = documents.result.findIndex((d) => d.docketItemId === docket.docketItemId);
    const copy = cloneDeep(documents);
    copy.result[documentIndex].seeMore = !copy.result[documentIndex].seeMore;

    queryClient.setQueryData(queryKey, copy);
  };

  return { toggleSeeMore };
};
